import Organizing from '../components/Committee/Organizing'
export default function OrganizingCommittee() {
    return(
        <main className='mt-28'>
        <Organizing />
        </main>
    )
}